/* Vibrant Publishers - Two-Tier Free Gift Automation */

(function () {
  if (window.__vbGiftsInitialized) return;
  window.__vbGiftsInitialized = true;

  // GIFT VARIANT IDs
  const MOUSE_ID = 67841119453227;
  const TOTE_ID = 67986648989739;

  // Offer thresholds (amounts in paise)
  const LOW_PRICE = 139000;  // Rs. 1390
  const HIGH_PRICE = 235000; // Rs. 2350

  const LOW_QTY = 3;
  const HIGH_QTY = 5;

  const root =
    (window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root) || "/";

  const url = (path) => root + path;
  const rawFetch = window.fetch.bind(window);

  let running = false;
  let again = false;
  let reloadRequested = false;

  // Shopify AJAX request
  const request = async (path, options) => {
    const res = await rawFetch(url(path), options);

    if (!res.ok) {
      throw new Error(path + " (" + res.status + ")");
    }

    return res.json();
  };

  // Update cart
  const post = (path, body) =>
    request(path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(body)
    });

  // Check gift availability
  const getAvailability = async (id) => {
    if (!id) return false;

    try {
      const variant = await request(
        "variants/" + id + ".js"
      );

      return variant.available === true;

    } catch (error) {
      console.warn(
        "Gift availability could not be verified",
        id,
        error
      );

      return false;
    }
  };

  // Show or hide reward bar based on stock
const refreshBar = (mouse, tote, quantity, amount) => {

  window.__vbGiftBarStock = {
    mouse, tote, quantity, amount
  };

  document.querySelectorAll(".vb-rw").forEach((el) => {

    // Hide entire UI if Mouse Pad is out of stock
    if (!mouse) {
      el.style.setProperty("display", "none", "important");
      return;
    }

    el.style.setProperty("display", "block", "important");

    const twoAvailable = mouse && tote;

    const lowUnlocked =
      quantity >= 3 || amount >= 139000;

    const highUnlocked =
      twoAvailable &&
      (quantity >= 5 || amount >= 235000);

    const targetAmount = twoAvailable ? 235000 : 139000;
    const targetQty = twoAvailable ? 5 : 3;

    const progress = Math.min(
      100,
      Math.max(
        amount / targetAmount,
        quantity / targetQty
      ) * 100
    );

    const formatMoney = (paise) =>
      "₹" + Math.max(0, paise / 100)
        .toLocaleString("en-IN", {
          maximumFractionDigits: 0
        });

    const heading = el.querySelector(".vb-rw__heading");
    const intro = el.querySelector(".vb-rw__intro");
    const fill = el.querySelector(".vb-rw__fill");
    const currentDot = el.querySelector(".vb-rw__current-dot");
    const cartLabel = el.querySelector(".vb-rw__cart-label");
    const nextLabel = el.querySelector(".vb-rw__next");
    const lowDot = el.querySelector(".vb-rw__low-dot");
    const highDot = el.querySelector(".vb-rw__high-dot");
    const footerText = el.querySelector(".vb-rw__footer-text");

    el.classList.toggle("vb-no-tote", !twoAvailable);
    el.classList.toggle("is-unlocked", lowUnlocked);

    el.querySelectorAll("[data-vb-tier2]").forEach((node) => {
      node.style.setProperty(
        "display",
        twoAvailable ? "" : "none",
        twoAvailable ? "" : "important"
      );
    });

    const nextAmount = lowUnlocked && twoAvailable
      ? 235000
      : 139000;

    const remaining = Math.max(0, nextAmount - amount);

    const nextQty = lowUnlocked && twoAvailable ? 5 : 3;
    const booksRemaining = Math.max(0, nextQty - quantity);

    if (heading) {
      if (highUnlocked) {
        heading.textContent = "🎁 You've unlocked 2 FREE Gifts!";
      } else if (lowUnlocked) {
        heading.textContent = "🎁 You've unlocked a FREE Mouse Pad!";
      } else {
        heading.innerHTML =
          "You're only " + formatMoney(remaining) +
          " away from a <span>FREE Mouse Pad!</span>";
      }
    }

    if (intro) {
      if (highUnlocked) {
        intro.textContent =
          "Congratulations! Your Mouse Pad and Tote Bag are unlocked.";
      } else if (lowUnlocked && twoAvailable) {
        intro.textContent =
          "Add " + booksRemaining +
          " more books or spend " +
          formatMoney(remaining) +
          " more to unlock your Tote Bag!";
      } else if (lowUnlocked) {
        intro.textContent =
          "Congratulations! Your FREE Mouse Pad is unlocked.";
      } else {
        intro.textContent =
          "Add more to your cart to unlock free gifts.";
      }
    }

    if (fill) {
      fill.style.width = progress + "%";
      fill.style.maxWidth = "100%";
      fill.style.background =
        "linear-gradient(90deg, #ffb52c, #79b52d, #078f47)";
    }

    if (currentDot) {
      currentDot.style.left = progress + "%";
    }

    if (cartLabel) {
      cartLabel.textContent = "Current cart: " + formatMoney(amount);

      // Keep the label inside the small cart drawer
      cartLabel.style.left =
        Math.max(15, Math.min(85, progress)) + "%";
    }

    if (nextLabel) {

  const showNext =
    !highUnlocked &&
    !(lowUnlocked && !twoAvailable);

  nextLabel.style.display = showNext ? "block" : "none";

  if (showNext) {

    if (lowUnlocked && twoAvailable) {
      // Tote Bag is next: align inside right edge
      nextLabel.style.left = "auto";
      nextLabel.style.right = "0";
      nextLabel.style.transform = "none";
    } else if (twoAvailable) {
      // Mouse Pad is next
      nextLabel.style.left = "59.15%";
      nextLabel.style.right = "auto";
      nextLabel.style.transform = "translateX(-50%)";
    } else {
      // Only Mouse Pad available
      nextLabel.style.left = "auto";
      nextLabel.style.right = "0";
      nextLabel.style.transform = "none";
    }

    nextLabel.textContent = "Next reward";
  }
}

    if (lowDot) {
      lowDot.classList.toggle("reached", lowUnlocked);
    }

    if (highDot) {
      highDot.classList.toggle("reached", highUnlocked);
    }

    if (footerText) {
      footerText.innerHTML =
        "Get a FREE Mouse Pad with 3 books or ₹1,390." +
        (twoAvailable
          ? '<span class="vb-rw__footer-tote">' +
            'Get a FREE Tote Bag and Mouse Pad with 5 books or ₹2,350.' +
            '</span>'
          : "");
    }
  });
};

  // Main gift synchronization
  async function run() {

    // Check both gifts' inventory
    const [mouseAvailable, toteAvailable] =
      await Promise.all([
        getAvailability(MOUSE_ID),
        getAvailability(TOTE_ID)
      ]);

    // refreshBar(mouseAvailable, toteAvailable);

    // Fetch cart
    const cart = await request("cart.js");

    const giftIds = [MOUSE_ID, TOTE_ID];

    // Exclude gift products from calculations
    const regularItems = cart.items.filter(
      (item) =>
        !giftIds.includes(Number(item.variant_id))
    );

    // Calculate total purchased quantity
    const quantity = regularItems.reduce(
      (total, item) =>
        total + Number(item.quantity || 0),
      0
    );

    // Calculate cart value excluding gifts
    const amount = regularItems.reduce(
      (total, item) =>
        total + Number(item.final_line_price || 0),
      0
    );

    // HIGH TIER:
    // 5 products OR Rs. 2350
    // Requires BOTH gifts available
    const highTier =
      mouseAvailable &&
      toteAvailable &&
      (
        quantity >= HIGH_QTY ||
        amount >= HIGH_PRICE
      );

    // LOW TIER:
    // 3 products OR Rs. 1390
    // Requires mouse pad available
    const lowTier =
      mouseAvailable &&
      (
        quantity >= LOW_QTY ||
        amount >= LOW_PRICE
      );

    // Decide required gifts
    const requiredGifts = new Map([
      [MOUSE_ID, lowTier || highTier],
      [TOTE_ID, highTier]
    ]);

    refreshBar(mouseAvailable, toteAvailable, quantity, amount);
    let changed = false;

    // Remove unwanted or extra gift quantities
    for (const id of giftIds) {

      const giftLines = cart.items.filter(
        (item) => Number(item.variant_id) === id
      );

      const required = requiredGifts.get(id);

      for (let i = 0; i < giftLines.length; i++) {

        const line = giftLines[i];

        const targetQuantity =
          required && i === 0 ? 1 : 0;

        if (
          Number(line.quantity) !== targetQuantity
        ) {

          await post("cart/change.js", {
            id: line.key,
            quantity: targetQuantity
          });

          changed = true;
        }
      }
    }

    // Fetch updated cart after removals
    const latestCart = changed
      ? await request("cart.js")
      : cart;

    // Add missing qualifying gifts
    for (const id of giftIds) {

      if (!requiredGifts.get(id)) continue;

      const alreadyExists = latestCart.items.some(
        (item) => Number(item.variant_id) === id
      );

      if (!alreadyExists) {

        await post("cart/add.js", {
          items: [
            {
              id: id,
              quantity: 1,
              properties: {
                _free_gift: "true"
              }
            }
          ]
        });

        changed = true;
      }
    }

    return changed;
  }

  // Schedule synchronization
  function schedule(reload) {

    reloadRequested =
      reloadRequested || !!reload;

    if (running) {
      again = true;
      return;
    }

    running = true;

    (async function drain() {

      let changedAny = false;

      try {

        do {
          again = false;

          changedAny =
            (await run()) || changedAny;

        } while (again);

      } catch (error) {

        console.error(
          "Free gift synchronization failed:",
          error
        );

      } finally {

        running = false;

        const shouldReload =
          changedAny && reloadRequested;

        reloadRequested = false;

        if (shouldReload) {

          try {
            sessionStorage.setItem(
              "reopen_cart_drawer",
              "1"
            );
          } catch (error) {}

          location.reload();
        }
      }

    })();
  }

  // Detect cart-changing requests
  const changedCart = (input) =>
    /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/i.test(
      String((input && input.url) || input || "")
    );

  // Monitor fetch-based cart updates
  window.fetch = function () {

    const needsSync =
      !running && changedCart(arguments[0]);

    const promise = rawFetch.apply(
      null,
      arguments
    );

    if (needsSync) {

      promise
        .then((response) => {

          if (response.ok) {

            setTimeout(
              () => schedule(true),
              200
            );
          }
        })
        .catch(() => {});
    }

    return promise;
  };

  // Monitor XMLHttpRequest cart updates
  const oldOpen = XMLHttpRequest.prototype.open;
  const oldSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (
    method,
    requestUrl
  ) {

    this.__vbGiftMutation = changedCart(requestUrl);

    return oldOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {

    if (!running && this.__vbGiftMutation) {

      this.addEventListener("load", () => {

        if (
          this.status >= 200 &&
          this.status < 300
        ) {

          setTimeout(
            () => schedule(true),
            200
          );
        }
      });
    }

    return oldSend.apply(this, arguments);
  };

  // Check gifts when customer opens cart
  document.addEventListener(
    "click",
    (event) => {

      if (
        event.target.closest(
          '#cart-icon, [href="/cart"], .cart-icon-bubble'
        )
      ) {

        setTimeout(
          () => schedule(false),
          300
        );
      }
    },
    true
  );

  // Initial gift check on page load
  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      () => schedule(false)
    );

  } else {

    schedule(false);
  }

  // Keep reward bar visible after cart drawer refreshes
  const vbRewardObserver = new MutationObserver((mutations) => {

    const stock = window.__vbGiftBarStock;

    if (!stock) return;

    let rewardBarAdded = false;

    for (const mutation of mutations) {

      for (const node of mutation.addedNodes) {

        if (node.nodeType !== 1) continue;

        if (
          node.matches?.(".vb-rw") ||
          node.querySelector?.(".vb-rw")
        ) {
          rewardBarAdded = true;
          break;
        }
      }

      if (rewardBarAdded) break;
    }

    if (rewardBarAdded) {

      refreshBar(
        stock.mouse,
        stock.tote,
        stock.quantity,
        stock.amount
      );

    }
  });

  vbRewardObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})();